import React, { useEffect } from 'react'
import { makeAutoObservable } from 'mobx'
import { observer } from 'mobx-react-lite'
import AdminApi from './../../../../api/admin-api/admin-api'

import './AnnualTheme.scss'

class ThemeStore {
  theme = null

  constructor() {
    makeAutoObservable(this)
  }

  fetchAnnualTheme = async () => {
    return new Promise((resolve, reject) => {
      this.theme = false

      AdminApi.getAgencyInfo()
        .then(result => resolve((this.theme = result?.data?.data?.a_annual_theme || '')))
        .catch(error => reject(error))
    })
  }
}

const Store = new ThemeStore()

const AnnualTheme = ({ onSuccess, onError }) => {
  const { theme, fetchAnnualTheme } = Store

  useEffect(() => {
    if (theme === null)
      fetchAnnualTheme().then(
        url => {
          url ? onSuccess() : onError()
        },
        () => {
          onError()
        }
      )
  }, [theme, fetchAnnualTheme, onSuccess, onError])

  return (
    <div id='AnnualThemeComponent'>
      <div className='mb-2 d-flex h-100 align-items-center' style={{ textAlign: 'center' }}>
        {theme ? <img alt='Stronger Together 2025' src={theme} className='img-fluid' /> : <></>}
      </div>
    </div>
  )
}

export default observer(AnnualTheme)
